import * as React from 'react';
import { useDynamicPhone, EPageTypes, EPlatformTypes } from '@cian/frontend-newbuilding-call-component';
import { UIHeading3 } from '@cian/ui-kit';
import { useSelector } from 'react-redux';

import { DynamicPhoneLinkWrapper } from '../../components/DynamicPhoneLinkWrapper';
import { PhoneLinkQRCode } from '../../components/PhoneLinkQRCode';
import { PhonesPreloader } from '../../components/PhonesPreloader';
import { getNewbuildingId } from '../../selectors/newbuilding';
import { useApplicationContext } from '../../utils/applicationContext';

interface INewbuildingDynamicPhoneProps {
  placeType: string;
  siteBlockId: number;
  notFormattedPhone: string | null;
  phoneNumber: string;
}

export const NewbuildingDynamicPhone = ({
  placeType,
  siteBlockId,
  phoneNumber,
  notFormattedPhone,
}: INewbuildingDynamicPhoneProps) => {
  const { httpApi, logger } = useApplicationContext();
  const newbuildingId = useSelector(getNewbuildingId);

  const { dynamicPhone, responseEnded, linkPhone } = useDynamicPhone({
    formattedPhone: phoneNumber,
    notFormattedPhone: notFormattedPhone || undefined,
    siteBlockId,
    httpApi,
    logger,
    placeType,
    pageType: EPageTypes.NewbuildingCard,
    platformType: EPlatformTypes.WebDesktop,
    announcementId: newbuildingId,
  });

  if (!responseEnded) {
    return <PhonesPreloader />;
  }

  return (
    <DynamicPhoneLinkWrapper>
      <a href={linkPhone} data-testid="PhoneLink">
        <UIHeading3>{dynamicPhone}</UIHeading3>
      </a>
      <PhoneLinkQRCode phoneLink={linkPhone} formattedPhone={dynamicPhone} />
    </DynamicPhoneLinkWrapper>
  );
};
